var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "554px",
    height: "797px",
    viewBox: "285.71697998046875 187.47044372558594 269.6767272949219 387.97357177734375",
    preserveAspectRatio: "xMinYMin meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "p",
    width: 8,
    height: 8
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "svgEditorBackground",
    x: 0,
    y: 0,
    width: 1280,
    height: 790,
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.3055339049,
    y: 202.5253312549,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    },
    id: "e1_rectangle",
    width: 120.714,
    height: 337.209,
    ry: 40.922,
    rx: 40.922
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.307,
    y: 430.987,
    style: {
      fill: "rgb(150, 150, 150)",
      strokeWidth: 1
    },
    id: "e3_rectangle",
    width: 157.631,
    height: 136.678
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.939,
    y: 430.99,
    style: {
      fill: "rgb(150, 150, 150)",
      strokeWidth: 1
    },
    id: "e4_rectangle",
    width: 98.769,
    height: 60.857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.814,491.722l-0.875,39.035l99.827,-39.966Z",
    style: {
      fill: "rgb(150, 150, 150)",
      strokeWidth: 1
    },
    id: "e6_pathH"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "e11_ellipse",
    cx: 365.718,
    cy: 381.574,
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 1
    },
    rx: 54.96,
    ry: 31.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.396,
    y: 365.25,
    width: 33.277,
    height: 32.803,
    fill: "#ffffff",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "matrix(0.246675, 0, 0, 0.242679, 334.508026, 352.998444)",
    style: {}
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 32)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 40)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 48)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 56)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 64)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 72)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 80)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 96)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 104)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 120)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 144)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 152)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 160)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 168)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 176)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 184)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 32, 192)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 40, 32)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 40, 80)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 40, 96)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 40, 112)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 40, 144)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 40, 192)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 32)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 48)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 56)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 64)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 80)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 96)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 112)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 120)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 128)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 144)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 160)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 168)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 176)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 48, 192)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 32)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 48)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 56)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 64)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 80)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 96)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 104)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 144)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 160)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 168)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 176)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 56, 192)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 32)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 48)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 56)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 64)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 80)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 104)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 120)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 128)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 144)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 160)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 168)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 176)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 64, 192)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 72, 32)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 72, 80)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 72, 104)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 72, 112)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 72, 120)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 72, 144)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 72, 192)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 32)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 40)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 48)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 56)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 64)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 72)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 80)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 96)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 112)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 128)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 144)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 152)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 160)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 168)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 176)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 184)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 80, 192)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 88, 112)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 88, 128)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 32)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 48)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 56)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 64)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 80)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 96)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 104)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 112)"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 136)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 168)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 176)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 184)"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 96, 192)"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 48)"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 56)"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 72)"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 96)"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 128)"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 144)"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 152)"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 104, 184)"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 32)"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 40)"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 72)"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 80)"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 96)"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 112)"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 128)"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 136)"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 152)"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 160)"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 176)"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 184)"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 112, 192)"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 32)"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 40)"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 48)"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 64)"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 72)"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 88)"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 96)"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 104)"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 112)"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 120)"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 136)"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 120, 144)"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 32)"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 56)"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 72)"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 80)"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 88)"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 96)"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 104)"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 128)"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 144)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 160)"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 128, 176)"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 136, 96)"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 136, 120)"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 136, 128)"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 136, 160)"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 136, 168)"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 32)"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 40)"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 48)"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 56)"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 64)"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 72)"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 80)"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 104)"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 112)"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 128)"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 184)"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 144, 192)"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 32)"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 80)"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 120)"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 136)"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 152)"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 160)"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 168)"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 176)"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 184)"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 152, 192)"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 32)"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 48)"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 56)"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 64)"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 80)"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 96)"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 104)"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 136)"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 144)"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 152)"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 160, 192)"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 32)"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 48)"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 56)"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 64)"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 80)"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 96)"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 112)"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 128)"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 136)"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 144)"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 168)"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 184)"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 168, 192)"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 32)"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 48)"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 56)"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 64)"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 80)"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 96)"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 104)"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 112)"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 144)"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 152)"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 160)"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 176)"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 176, 192)"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 184, 32)"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 184, 80)"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 184, 104)"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 184, 136)"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 184, 144)"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 184, 152)"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 184, 168)"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 32)"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 40)"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 48)"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 56)"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 64)"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 72)"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 80)"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 96)"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 104)"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 112)"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 152)"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "matrix(1, 0, 0, 1, 192, 184)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.143436, 0, 0, 0.14139, 347.396179, 365.250031)",
    style: {}
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.c04868536b32c7ffc5a98820ca503e09.svg";
export { ForwardRef as ReactComponent };